import { LocaleString, LocaleType } from '../types/general';

export function printLocaleString(
  localeStr: LocaleString | null | undefined | string,
  locale: LocaleType = 'en',
): string {
  if (typeof localeStr === 'string') return localeStr;
  return localeStr?.[locale] ?? '';
}
